import React, { FC, ReactNode } from "react";
import { Mouse } from "../../typings/event.types";

export const Button: FC<{
  onClick?: (evt: Mouse) => void;
  children: ReactNode;
  className?: string;
}> = ({ children, ...restProps }) => <button {...restProps}>{children}</button>;
